import React from "react";
import { Phone } from "lucide-react";
import { PHONE_TEL, PHONE_DISPLAY, SERVICE_AREAS } from "../../data";
import LeadForm from "../LeadForm";
import { Reveal, Eyebrow, H2 } from "./Typo";

export default function FinalCta() {
  return (
    <section id="schedule" data-testid="final-cta" className="section-pad bg-[#172B38] text-[#F4F1E9] scroll-mt-0 grain relative">
      <div className="container-hw relative grid lg:grid-cols-12 gap-14">
        <Reveal className="lg:col-span-5">
          <Eyebrow light>Free in-home water test</Eyebrow>
          <H2 light className="mt-6">Start With Knowing Your Water.</H2>
          <p className="mt-7 text-[1.1rem] leading-relaxed text-[#F4F1E9]/75 max-w-md">Every home is different. Let's take a look at your water and find out what makes sense for yours.</p>
          <a href={`tel:${PHONE_TEL}`} data-testid="final-call" className="btn-ghost-light mt-10"><Phone className="w-4 h-4" strokeWidth={1.5} /> Call Us · {PHONE_DISPLAY}</a>
          <div className="mt-14 pt-8 border-t border-[#F4F1E9]/15 max-w-md">
            <p className="text-sm text-[#8CAFC0]">Serving Northern Virginia</p>
            <p className="mt-2 text-[0.95rem] text-[#F4F1E9]/70">{SERVICE_AREAS.join(" · ")}</p>
          </div>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-6 lg:col-start-7">
          <LeadForm dark id="final-form" source="Website Schedule Form" />
        </Reveal>
      </div>
    </section>
  );
}
